<template>
  <div class="transaction-container">
    <div class="flex gap-4 overflow-x-auto">
      <menu-button
        :menus="menus"
        :menuActive="menuActive"
        @menu-change="menuChange"
      />
    </div>
    <template v-if="transactions.length">
      <div
        v-for="item in transactions"
        :key="item._id"
        class="list-transaction"
      >
        <card-course-transaction :transactionData="item" />
      </div>
    </template>
    <template v-else>
      <div class="mt-10">Tidak ada transaksi</div>
    </template>
  </div>
</template>

<script>
const MenuButton = () => import('@/components/App/Menus/Button')
const CardCourseTransaction = () => import('@/components/Shared/CardCourse/CourseTransaction')
const menus = [
  {
    key: 1,
    name: 'Semua',
    status: 'all',
  },
  {
    key: 2,
    name: 'Selesai',
    status: 'success',
  },
  {
    key: 3,
    name: 'Menunggu Pembayaran',
    status: 'pending',
  },
  {
    key: 4,
    name: 'Dibatalkan',
    status: 'cancel',
  },
]

export default {
  components: {
    MenuButton,
    CardCourseTransaction,
  },
  data() {
    return {
      menus,
      menuActive: 1,
      transactions: [],
    }
  },
  methods: {
    menuChange(key) {
      const menu = this.menus.find(el => el.key === key)
      this.transactions = menu.status === 'all' ? this.transactions : this.transactions.filter(el => el.status === menu.status)
      this.menuActive = key
      this.fetchUserTransactionHistory(key)
    },
    fetchUserTransactionHistory(key) {
      key = this.menuActive
      const menu = this.menus.find(el => el.key === key)
      const status = menu.status
      this.$store.dispatch('transaction/GET_USER_TRANSACTION_HISTORY', { status })
        .then(res => {
          // console.log('fetchUserTransactionHistory res => ', res)
          this.transactions = res
        })
        .catch(err => {
          console.log('fetchUserTransactionHistory err => ', err)
          this.notification.error({
            title: 'Error',
            message: err.message,
            duration: 3000,
          })
        })
    },
  },
  mounted() {
    this.fetchUserTransactionHistory()
  },
}
</script>

<style lang="scss">
.transaction-container {
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .list-transaction {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
</style>
